import React, { useState } from 'react';
import t from '../Translation/Translation';

function ThemeSwitcher(props) {
    
    const setStoredTheme = theme => localStorage.setItem('theme', theme);
    const [theme, setTheme] = useState(localStorage.getItem('theme') ? localStorage.getItem('theme') : (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'));

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    const shouldAdd = newTheme === 'dark' ? true : false;
    document.documentElement.setAttribute('data-bs-theme', newTheme);
    document.documentElement.classList.toggle('ion-palette-dark', shouldAdd);
    setTheme(newTheme);
    setStoredTheme(newTheme);
  };

  return (
    <div className={props.classes} onClick={toggleTheme}>
        {props.icon ? props.icon : ''} {props.text ? props.text : 'Toogle theme'}
    </div>
  );
}

export default ThemeSwitcher;